import { useEffect, useState } from 'react';
import { KBoardUtils } from 'src/utils';

export const NO_FOCUS = -1;

export const useFocus = (suggest: unknown[] = [], ref: any = undefined) => {
    const [currIdx, setIdx] = useState<number>(NO_FOCUS);

    const onKeyUp = (e: KeyboardEvent) => {
        const length = suggest.length;
        if (KBoardUtils.isKeyUp(e)) {
            let nextIdx = currIdx - 1;
            if (nextIdx < NO_FOCUS) {
                return setIdx(length);
            } else {
                setIdx(nextIdx);
            }
        } else if (KBoardUtils.isKeyDown(e)) {
            let nextIdx = currIdx + 1;
            if (nextIdx > length) {
                setIdx(NO_FOCUS);
            } else {
                setIdx(nextIdx);
            }
        }
    };
    useEffect(() => {
        setIdx(NO_FOCUS);
    }, [suggest]);

    useEffect(() => {
        if (ref?.current) {
            ref.current.addEventListener('keydown', onKeyUp);
            return () => {
                ref.current?.removeEventListener('keydown', onKeyUp);
            };
        } else {
            document.addEventListener('keydown', onKeyUp);
            return () => {
                document.removeEventListener('keydown', onKeyUp);
            };
        }
    }, [suggest, currIdx]);

    return currIdx;
};

export default useFocus;